export const STEP = {
  LOCATION: 'location',
  SIMULATOR: 'simulator',
  SIMULATOR_RESULTS: 'simulator_results',
  CUSTOMER: 'customer',
  STAKEHOLDERS: 'stakeholders',
  MAJORITY_SHAREHOLDER: 'majority_shareholder',
  SAT_CONNECTION: 'sat_connection',
  CREDIT_BUREAU_AUTH: 'credit_bureau_authorization',
  CREDIT_BUREAU_OTP: 'credit_bureau_otp',
  PRE_PROPOSAL: 'preproposal',
  PROPIETARIO_REAL_PLD: 'propietario_real_pld',
  DOCUMENTATION: 'documentation',
  DOCUMENTATION_SHAREHOLDER: 'documentation_shareholder',
  FINISH: 'finish',
  PROCESSING: 'processing',
  RELATIONSHIPS: 'relationships',
  REGISTER: 'register',
  REGISTER_CONFIRM: 'register_sms',
  REGISTER_CODE: 'register_code',
  CREDIT_HISTORY_CHECK: 'credit_history_check',
  CREDIT_CONFIRMATION: 'credit_confirmation',
};

export const STEPS = [
  {
    header: 'Crea tu cuenta',
    label: 'Registro',
    name: STEP.REGISTER,
    title: 'Registro',
    isVisible: false,
  },
  {
    header: 'Autoriza tu consulta en circulo de credito',
    index: 0,
    label: 'Autoriza tu consulta en circulo de credito',
    name: STEP.REGISTER_CODE,
    title: 'Autoriza tu consulta en circulo de credito',
    isVisible: false,
    description: 'Ingresa el codigo que se envio a tu WhatsApp',
  },
  {
    description: 'Enviamos un mensaje con el codigo al correo electronico',
    header: 'Verifica tu correo electronico',
    resendMessage: 'Reenviar codigo de verificacion',
    index: 0,
    isVisible: false,
    name: STEP.REGISTER_CONFIRM,
    title: 'Registro',
  },
  {
    header: 'Permitir ubicacion',
    index: 0,
    label: 'Ubicacion',
    name: STEP.LOCATION,
    title: 'Ubicacion',
    isVisible: false,
  },
  {
    header: 'Datos generales',
    index: 1,
    label: 'Datos Generales',
    name: STEP.CUSTOMER,
    title: 'Cliente',
  },
  {
    header: 'Accionistas',
    index: 1,
    label: 'Accionistas',
    name: STEP.STAKEHOLDERS,
    title: 'Accionistas',
    isVisible: false,
  },
  {
    header: 'Accionista mayoritario',
    index: 1,
    label: 'Accionista mayoritario',
    name: STEP.MAJORITY_SHAREHOLDER,
    title: 'Accionista mayoritario',
    isVisible: false,
  },
  {
    header: 'Conexion SAT',
    index: 2,
    label: 'Conexion SAT',
    name: STEP.SAT_CONNECTION,
    title: 'Conexion SAT',
  },
  {
    header: 'Autorizaciones Buro de Credito',
    index: 3,
    label: 'Buro de Credito',
    name: STEP.CREDIT_BUREAU_AUTH,
    title: 'Autorizaciones Buro de Credito',
    isVisible: false,
  },
  {
    header: 'Verificacion de codigo',
    index: 3,
    label: 'Verificacion',
    name: STEP.CREDIT_BUREAU_OTP,
    title: 'Verificacion de codigo',
    isVisible: false,
  },
  {
    header: 'Prepropuesta',
    index: 4,
    label: 'Prepropuesta',
    name: STEP.PRE_PROPOSAL,
    title: 'Prepropuesta',
  },
  {
    header: 'Propietario real / PLD',
    index: 5,
    label: 'Propietario Real-PLD',
    name: STEP.PROPIETARIO_REAL_PLD,
    title: 'Propietario real / PLD',
  },
  {
    header: 'Carga de documentacion',
    index: 6,
    label: 'Documentacion',
    name: STEP.DOCUMENTATION,
    title: 'Carga de documentacion',
  },
  {
    header: 'Documentacion accionista persona moral',
    index: 6,
    label: 'Accionista PM',
    name: STEP.DOCUMENTATION_SHAREHOLDER,
    title: 'Documentacion accionista persona moral',
    isVisible: false,
  },
  {
    header: 'Referencias',
    index: 1,
    label: 'Referencias',
    name: STEP.RELATIONSHIPS,
    title: 'Referencias',
    isVisible: false,
  },
  {
    header: 'Proceso finalizado exitosamente',
    index: 7,
    label: 'Finalizado',
    name: STEP.FINISH,
    title: 'Proceso finalizado exitosamente',
    isVisible: false,
  },
];

export const getStepperState = (currentStep) => {
  const visibleSteps = STEPS.filter((item) => item.isVisible !== false);
  if (currentStep === STEP.FINISH) {
    return {
      visibleSteps,
      activeIndex: visibleSteps.length,
    };
  }
  const currentIndex = STEPS.findIndex((item) => item.name === currentStep);

  if (currentIndex < 0) {
    return {
      visibleSteps,
      activeIndex: 0,
    };
  }

  let mappedIndex = currentIndex;
  while (mappedIndex >= 0 && STEPS[mappedIndex].isVisible === false) {
    mappedIndex -= 1;
  }

  const mappedStepName = STEPS[mappedIndex]?.name ?? STEPS[currentIndex]?.name;
  const activeIndex = visibleSteps.findIndex((item) => item.name === mappedStepName);

  return {
    visibleSteps,
    activeIndex: activeIndex >= 0 ? activeIndex : 0,
  };
};
